import UploadPlaceholder from './UploadPlaceholder';

export default UploadPlaceholder;
